<!--
* 下拉树形选择框组件
*name:汪鑫
* description：select-tree简单的下拉单选功能,
*
-->
/* 使用说明 */
<!-- <treeSelectInput>
   :treeData="treeData"
   :defaultProps="defaultProps"
   :defaultCheckData="defaultCheckData"
   :value.sync="value"
   :nodeKey="nodeKey"
   @changeSelect="changeSelect"
   :placeholder="placeholder"
   :width="width"
</treeSelectInput> 
-->
<template>
  <div class="tree-select">
    <el-select
      ref="treeSelect"
      v-model="value"
      :placeholder="placeholder"
      class="tree-input"
      :style="{ width: `${width}px` }"

    >
      <el-option class="option-sty" value=''>
        <el-tree
          ref="tree"
          class="tree"
          :node-key="nodeKey"
          show-checkbox
          icon-class="el-icon-arrow-right"
          check-strictly
          highlight-current
          :props="defaultProps"
          :default-checked-keys="defaultCheckData"
          :default-expanded-keys="defaultCheckData"
          :data="treeData"
          @check-change="checkChange"
        ></el-tree>
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: "treeSelectInput",
  props: {
    /* nodeKey:节点唯一标识，每个节点不能一致 */
    nodeKey: {
      type: String,
      default: "id",
    },
    /* value:输入框回显值 */
    value: {
      type: String,
      default: "",
    },
    /* 树组件显示数据 */
    treeData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /* 树结构数据配置项 */
    defaultProps: {
      type: Object,
      default: () => {
        return {
          children: "children",
          label: "label",
        };
      },
    },
    /* 树结构默认选中数据 */
    defaultCheckData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /* 输入框提示语 */
    placeholder: {
      type: String,
      default: "请选择",
    },
    /* 选择框宽度 */
     width: {
      type: Number,
      default: 250,
    },
  },
  data() {
    return {};
  },
  methods: {
    /* 树结构点击事件
     *data当前点击节点对象
     *checked：节点本身是否被选中、
     *node：节点的子树中是否有被选中的节点
     */
    checkChange(data, checked, node) {
      if (checked) {
        this.$refs.tree.setChecked(this.$refs.tree.getCurrentNode, false); // 取消当前节点的选中状态
        this.value = data.name;
        this.$emit("update:value",data.name)
        this.$refs.tree.setCheckedKeys([data.id]); // 选中当前点击节点
        this.$emit("changeSelect", data);   //把当前选中节点数据传给父级
        this.$refs.treeSelect.visible = false; //关闭弹框
      }
    },
  },
  watch: {
      value(){
           this.$emit("update:value",this.value)
      }
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.tree-input{
  /deep/.el-input__inner{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
.option-sty {
  height: auto;
  padding: 0px !important;
  /deep/.el-checkbox__inner {
    border-radius: 50%;
  }
  .el-select-dropdown .el-popper {
    min-width: 300px;
  }
  /deep/.el-tree-node__label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    margin-right: 24px;
  }
  /deep/.el-tree-node__content > .el-tree-node__expand-icon {
    padding: 6px;
    right: 6px;
    position: absolute;
  }
  /deep/.el-tree {
    // padding-left: 10px;
    min-width: 290px;
  }
  /deep/.el-tree-node__content>label.el-checkbox {
    margin-left: 8px;
}
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner::after {
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background-color: #fff;
    content: "";
    position: absolute;
    left: 35%;
    top: 35%;
  }
  /deep/.el-checkbox__inner::after {
    border: none;
    border-left: none;
    border-top: none;
  }
}
</style>